import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import StepBar from "../utils/StepBar";
import "./ApplicantLandingStepTwo.css";

const ApplicantLandingStepTwo = ({
  applicant,
  setApplicant,
  goToNextStep,
  goBack,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      whyInterested: applicant.whyInterested || "",
      codingExperience: applicant.codingExperience || "",
      education: applicant.education || "",
      age: applicant.age || "",
      gender: applicant.gender || "",
      country: applicant.country || "south-africa",
      phoneNumber: applicant.phoneNumber || "",
    },
  });

  const onSubmit = (data) => {
    setApplicant((prev) => ({
      ...prev,
      ...data,
    }));
    console.log("Form Data:", data);
    goToNextStep();
  };

  return (
    <div className="applicant-step-two-container">
      <div className="header-container">
        <h1 className="main-heading">Program Registration</h1>
      </div>
      <StepBar
        totalSteps={3}
        currentStep={2}
        labels={["Program Selection", "Personal Details", "Preferences"]}
      />

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="dropdown-container">
          <label htmlFor="whyInterested">
            Why are you interested in registering?
          </label>
          <select
            id="whyInterested"
            {...register("whyInterested", { required: true })}
            className="dropdown"
          >
            <option value="">Select an option</option>
            <option value="career">
              I want to start a career as a developer
            </option>
            <option value="upskill">
              I want to upskill myself for my current career
            </option>
            <option value="product">
              I have a product idea that I want to develop
            </option>
            <option value="curious">I am just code curious</option>
            <option value="trial">
              I am actually just interested in the free trial
            </option>
          </select>
          {errors.whyInterested && (
            <span className="error">This field is required</span>
          )}
        </div>

        <div className="dropdown-container">
          <label htmlFor="codingExperience">
            What coding experience do you have?
          </label>
          <select
            id="codingExperience"
            {...register("codingExperience", { required: true })}
            className="dropdown"
          >
            <option value="">Select an option</option>
            <option value="none">I have no coding experience at all</option>
            <option value="played">
              I played around in code, but nothing serious
            </option>
            <option value="experience">
              I have prior coding experience from my education or work
            </option>
          </select>
          {errors.codingExperience && (
            <span className="error">This field is required</span>
          )}
        </div>

        <div className="dropdown-container">
          <label htmlFor="education">Education Background</label>
          <select
            id="education"
            {...register("education", { required: true })}
            className="dropdown"
          >
            <option value="">Select an option</option>
            <option value="none">None</option>
            <option value="highschool">Highschool</option>
            <option value="diploma">Diploma</option>
            <option value="degree">Degree</option>
            <option value="postgraduate">Post Graduate</option>
          </select>
          {errors.education && (
            <span className="error">This field is required</span>
          )}
        </div>

        <div className="dropdown-container">
          <label htmlFor="age">What is your Age?</label>
          <select
            id="age"
            {...register("age", { required: true })}
            className="dropdown"
          >
            <option value="">Select an option</option>
            <option value="under18">Under 18</option>
            <option value="18-24">18 - 24</option>
            <option value="25-34">25 - 34</option>
            <option value="35-40">35 - 40</option>
            <option value="40-55">40 - 55</option>
            <option value="55+">55+</option>
          </select>
          {errors.age && <span className="error">This field is required</span>}
        </div>

        <div className="dropdown-container">
          <label htmlFor="gender">Gender</label>
          <select
            id="gender"
            {...register("gender", { required: true })}
            className="dropdown"
          >
            <option value="">Select an option</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          {errors.gender && (
            <span className="error">This field is required</span>
          )}
        </div>

        <div className="dropdown-container">
          <label htmlFor="country">Country of Residence</label>
          <select
            id="country"
            {...register("country", { required: true })}
            className="dropdown"
          >
            <option value="south-africa">South Africa</option>
            {/* Add more countries here */}
          </select>
          {errors.country && (
            <span className="error">This field is required</span>
          )}
        </div>

        <div className="input-container">
          <label htmlFor="phoneNumber">Phone Number</label>
          <input
            type="text"
            id="phoneNumber"
            {...register("phoneNumber", {
              required: "Phone number is required",
              pattern: {
                value: /^[0-9]{10}$/, // Example regex for a 10-digit phone number
                message: "Please enter a valid 10-digit phone number",
              },
            })}
            className="text-input"
          />
          {errors.phoneNumber && (
            <span className="error">{errors.phoneNumber.message}</span>
          )}
        </div>

        <div className="button-container">
          <button type="button" onClick={goBack} className="back-button">
            Back
          </button>
          <button type="submit" className="continue-button">
            Continue
          </button>
        </div>
      </form>
    </div>
  );
};

export default ApplicantLandingStepTwo;
